import { useMemo } from "react"
import { useVenue } from "providers/venue"
import { generateMenuConfig } from "./utils"
import {
  navigations as defaultNavigations,
  bottomNavigations as defaultBottomNavigations,
  kioskNavigations as defaultKioskNavigations,
  kioskMainNavigations as defaultKioskMainNavigations,
} from "standard"

import uniqBy from "lodash/uniqBy"
import get from "lodash/get"

export const useAppNavigation = () => {
  const { appConfig } = useVenue()
  const {
    mobileNavigations = [],
    mobileMainNavigations = [],
    kioskNavigation = [],
    kioskMainNavigations = [],
  } = useMemo(
    () => ({
      mobileNavigations: generateMenuConfig(
        defaultNavigations,
        get(appConfig, "mobile.navigation.menus")
      ),
      mobileMainNavigations: generateMenuConfig(
        defaultBottomNavigations,
        get(appConfig, "mobile.navigation.main")
      ),
      kioskNavigation: generateMenuConfig(
        defaultKioskNavigations,
        get(appConfig, "kiosk.navigation.menus")
      ),
      kioskMainNavigations: generateMenuConfig(
        defaultKioskMainNavigations,
        get(appConfig, "kiosk.navigation.main")
      ),
    }),
    [appConfig]
  )

  const allNavigations = useMemo(
    () =>
      uniqBy([...mobileNavigations, ...kioskNavigation], (navigation) =>
        get(navigation, "to")
      ),
    [mobileNavigations, kioskNavigation]
  )
  return {
    navigations: allNavigations,
    mobileNavigations,
    mobileMainNavigations,
    kioskNavigation,
    kioskMainNavigations,
  }
}
